import cn from 'classnames';
import { SyntheticEvent, useState } from 'react';

import ArrowDownIcon from '@icons/24/arrow-down_new.svg';

import styles from './MobileAccordionItem.module.scss';
import { MobileAccordionItemProps } from './types';

const MobileAccordionItem = ({
    title,
    children,
    defaultOpen = false,
    variant = 'default',
    className,
}: MobileAccordionItemProps) => {
    const isDeliveryVariant = variant === 'delivery';
    const [isOpen, setIsOpen] = useState(defaultOpen);

    const handleToggle = (event: SyntheticEvent<HTMLDetailsElement>) => {
        setIsOpen(event.currentTarget.open);
    };

    return (
        <details
            className={cn(
                styles.mobileAccordionItem,
                isDeliveryVariant && styles.mobileAccordionItem_delivery,
                className
            )}
            open={isOpen}
            onToggle={handleToggle}
        >
            <summary className={styles.mobileAccordionHeader}>
                <span className={styles.mobileAccordionTitle}>{title}</span>
                <ArrowDownIcon className={styles.mobileAccordionIcon} aria-hidden />
            </summary>
            <div className={styles.mobileAccordionBody}>{children}</div>
        </details>
    );
};

export default MobileAccordionItem;
